import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const getUserAddresses = async (userId) => {
  const res = await axiosInstance.get(`${backendUrl}/api/addresses/user/${userId}`);
  return res.data;
}; 

const saveAddress = async (userId, data) => {
  const res = await axiosInstance.post(`${backendUrl}/api/addresses/user/${userId}`, data);
  return res.data;
};

const saveSelectedAddress = async (userId, data) => {
  const res = await axiosInstance.post(`${backendUrl}/api/addresses/selected/user/${userId}`, data);
  return res.data;
};

export const updateAddress = async (id, data) => {
  const res = await axiosInstance.put(`${backendUrl}/api/addresses/${id}`, data);
  return res.data;
};

 export const deleteAddress = async (id) => {
   const res = await axiosInstance.delete(`${backendUrl}/api/addresses/${id}`);
  return res.data;
  };

 export const deleteUserAddress = async (userId,id) => {
   const res = await axiosInstance.delete(`${backendUrl}/api/addresses/${id}/selected/user/${userId}`);
  return res;
  };

 export const fetchSupplierAddresses = async () => {
   
     const res = await axiosInstance.get(`${backendUrl}/api/supplier-addresses`);
  return res.data;
  };

 export const saveSupplierAddresses = async (data) => {
   
     const res = await axiosInstance.post(`${backendUrl}/api/supplier-addresses`, data);
  return res.data;
  };

 export const updateSupplierAddresses = async (id, data) => { 
   //alert(id);
     const res = await axiosInstance.put(`${backendUrl}/api/supplier-addresses/${id}`, data);
  return res.data;
  };

 export const deleteSupplierAddresses = async (id) => {
   const res = await axiosInstance.delete(`${backendUrl}/api/supplier-addresses/${id}`);
  return res.data;
  };

 export const deleteSupplierSupplierAddresses = async (id,supplierId) => {
   const res = await axiosInstance.delete(`${backendUrl}/api/supplier-addresses/${id}/suppliers/${supplierId}`);
  return res.data;
  };

 export const saveAllSupplierAddresses = async (data) => {
   
     const res = await axiosInstance.post(`${backendUrl}/api/supplier-addresses/supplier`, data);
  return res.data;
  };

export default { getUserAddresses, saveAddress, saveSelectedAddress, updateAddress , fetchSupplierAddresses, saveSupplierAddresses, updateSupplierAddresses, deleteSupplierAddresses, saveAllSupplierAddresses,deleteSupplierSupplierAddresses, deleteAddress, deleteUserAddress };
 